import BConfig from "../../modules/BConfig";
import BRequest from "../../modules/BRequest";
import BEnergy from "../Modules/BEnergy";
import BQuantity from "../Modules/BQuantity";

export default class BDiaryNutrientGoalTemplateForm
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.diary-nutrient-goal-template-form`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("change", function (event) {
			if (event.target.matches(`${BDiaryNutrientGoalTemplateForm.selector()} [name="programId"]`)) {
				const form = new BDiaryNutrientGoalTemplateForm(event.target.closest(BDiaryNutrientGoalTemplateForm.selector()));
				form.setNutrientsFromProgram();
			}
		});

		document.addEventListener("change", function (event) {
			if (event.target.matches(`${BDiaryNutrientGoalTemplateForm.selector()} [name^="nutrientAmount_"]`)) {
				const form = new BDiaryNutrientGoalTemplateForm(event.target.closest(BDiaryNutrientGoalTemplateForm.selector()));
				form.recalculateNutrients(event.target.name);
			}
		});

		document.addEventListener("change", function (event) {
			if (event.target.matches(`${BDiaryNutrientGoalTemplateForm.selector()} [name="isCustom"]`)) {
				const form = new BDiaryNutrientGoalTemplateForm(event.target.closest(BDiaryNutrientGoalTemplateForm.selector()));
				form.setIsCustom(event.target.checked);
			}
		});

		document.addEventListener("change", function (event) {
			if (event.target.matches(`${BDiaryNutrientGoalTemplateForm.selector()} [name="nutrientPracticalUnitId_ENERGY"]`)) {
				const selectElement = event.target;
				const amountElement = document.querySelector(`${BDiaryNutrientGoalTemplateForm.selector()} [name="nutrientAmount_ENERGY"]`);

				const sourceUnit = selectElement.dataset.unitAbbr;
				const targetUnit = selectElement.options[selectElement.selectedIndex].text;

				selectElement.dataset.unitAbbr = targetUnit;

				amountElement.value = BDiaryNutrientGoalTemplateForm.convertEnergyAmountForUnitChange(
					amountElement,
					sourceUnit,
					targetUnit,
				);
			}
		});
	}

	static parseFormNumber(value)
	{
		if (value == null || value === "") {
			return NaN;
		}

		return parseFloat(String(value).replace(/\s+/g, "").replace(",", "."));
	}

	static energyUnitDatasetKey(unit)
	{
		return String(unit).toUpperCase() === "KJ" ? "kj" : "kcal";
	}

	static convertEnergyAmountForUnitChange(amountElement, sourceUnit, targetUnit)
	{
		const current = BDiaryNutrientGoalTemplateForm.parseFormNumber(amountElement.value);
		const canonicalSource = BDiaryNutrientGoalTemplateForm.parseFormNumber(
			amountElement.dataset[BDiaryNutrientGoalTemplateForm.energyUnitDatasetKey(sourceUnit)],
		);
		const canonicalTarget = amountElement.dataset[BDiaryNutrientGoalTemplateForm.energyUnitDatasetKey(targetUnit)];

		if (canonicalTarget != null && canonicalTarget !== "" && current === canonicalSource) {
			return String(canonicalTarget).replace(".", ",");
		}

		const energy = new BEnergy(current, sourceUnit);

		return energy.getQuantity(targetUnit).getFormAmount();
	}

	getNutrientParams()
	{
		return {
			"energy": this.el.querySelector(`[name="nutrientAmount_ENERGY"]`).value,
			"carbs": this.el.querySelector(`[name="nutrientAmount_CARBS"]`).value,
			"fats": this.el.querySelector(`[name="nutrientAmount_FATS"]`).value,
			"proteins": this.el.querySelector(`[name="nutrientAmount_PROTEINS"]`).value,
		};
	}

	getEnergyUnitAbbr()
	{
		const energyUnitElement = this.el.querySelector(`[name="nutrientPracticalUnitId_ENERGY"]`);

		return energyUnitElement.options[energyUnitElement.selectedIndex].text.trim();
	}

	getSourceFieldFromInputName(inputName)
	{
		const match = inputName.match(/^nutrientAmount_(.+)$/);
		return match ? match[1] : null;
	}

	getProgramId()
	{
		const programElement = this.el.querySelector(`[name="programId"]`);
		if (!programElement) {
			return null;
		}

		return parseInt(programElement.value);
	}

	getIsCustom()
	{
		const isCustomElement = this.el.querySelector(`[name="isCustom"]`);

		return isCustomElement ? isCustomElement.checked : true;
	}

	setNutrientsFromProgram()
	{
		const url = BConfig.getRoute("api.v2.diets.getNutrientQuantities")
			.replace("{dietId}", this.getProgramId())
			;

		BRequest.get(url, null, {
			headers: {
				"Accept": "application/json",
			}
		}).then(response => {
			Object.entries(response.data).forEach(([nutrientCode, nutrientQuantity]) => {
				const element = this.el.querySelector(`.diary-nutrient-goal-template-table__nutrient-quantity--${nutrientQuantity.nutrient.code}`);
				if (nutrientQuantity.nutrient.code == "ENERGY") {
					const energy = new BEnergy(nutrientQuantity.quantity.amount, nutrientQuantity.quantity.unit.abbr);
					const kcalQuantity = energy.getQuantity("kcal");
					const kjQuantity = energy.getQuantity("kJ");
					element.querySelector(`.diary-nutrient-goal-template-table__nutrient-amount--KCAL`).innerHTML = kcalQuantity.getReadable();
					element.querySelector(`.diary-nutrient-goal-template-table__nutrient-amount--KJ`).innerHTML = kjQuantity.getReadable();
					const amountInput = this.el.querySelector(`[name="nutrientAmount_ENERGY"]`);
					if (amountInput) {
						amountInput.dataset.kcal = String(Math.round(kcalQuantity.getAmount()));
						amountInput.dataset.kj = String(Math.round(kjQuantity.getAmount()));
					}
				} else {
					const quantity = new BQuantity(nutrientQuantity.quantity.amount, nutrientQuantity.quantity.unit.abbr);
					element.querySelector(`.diary-nutrient-goal-template-table__nutrient-amount--G`).innerHTML = quantity.getReadable();
				}
			});
		}).catch(error => {
			console.log(error);
		});
	}

	recalculateNutrients(changedInputName)
	{
		if (!this.getIsCustom()) {
			return;
		}

		const url = BConfig.getRoute("api.v2.diaryNutrientGoalTemplates.calculate");
		const data = {
			...this.getNutrientParams(),
			"sourceField": this.getSourceFieldFromInputName(changedInputName),
			"energyUnit": this.getEnergyUnitAbbr(),
		};

		BRequest.get(url, data, {
			headers: {
				"Accept": "application/json",
			}
		}).then(response => {
			if (!response.data.derivedField || response.data.derivedAmount === null) {
				return;
			}

			this.setFieldValue(response.data.derivedField, response.data.derivedAmount);
		}).catch(error => {
			console.log(error);
		});
	}

	setFieldValue(fieldCode, amount)
	{
		const input = this.el.querySelector(`[name="nutrientAmount_${fieldCode}"]`);
		if (!input) {
			return;
		}

		if (fieldCode === "ENERGY") {
			const energy = new BEnergy(amount, this.getEnergyUnitAbbr());
			input.value = energy.getQuantity(this.getEnergyUnitAbbr()).getFormAmount();
		} else {
			const quantity = new BQuantity(amount, "g");
			input.value = quantity.getFormAmount();
		}
	}

	setIsCustom(isCustom)
	{
		this.el.querySelectorAll(`.diary-nutrient-goal-template-table__custom, .diary-nutrient-goal-template-form__custom-instructions`).forEach(el => {
			el.hidden = !isCustom;
		});
	}
}
